export const messages = {
  en: {
    chainProduct: {
      productList: 'Product List',
      productDetail: 'Product Detail',
      productId: 'Product ID',
      productImage: 'Product Image',
      productCatalog: 'Product Catalog',
      productName: 'Product Name',
      productUnit: 'Product Unit',
      sortOrder: 'Sort Order',
      status: 'Status',
      createTime: 'Create Time',
      operations: 'Operations',
      queryCondition: 'Query Condition',
      inputProdName: 'Please enter product name',
      confirmDeleteProduct: 'Are you sure to delete this product?',
      onShelf: 'On Shelf',
      offShelf: 'Off Shelf',
      editProduct: 'Edit Product',
      viewProduct: 'View Product',
      productSpec: 'Product Specification',
      specName: 'Spec Name',
      specValue: 'Spec Value',
      price: 'Price',
      purchaseQuantity: 'Purchase Quantity',
      pricingStrategy: 'Pricing Strategy',
      remark: 'Remark',
      fixedPrice: 'Fixed Price',
      floatingPrice: 'Floating Price',
      confirmOrder: 'Confirm Order',
      orderSuccess: 'Order Success',
      productDesc: 'Description',
      coverPhoto: 'Cover Photo',
      carouselPhotos: 'Carousel Photos'
    },
    addChainSupplier: {
      addSupplier: 'Add Supplier',
      supplierName: 'Supplier Name',
      supplierNamePlaceholder: 'Please enter supplier name',
      appId: 'App ID',
      appIdPlaceholder: 'Please enter App ID',
      appSecure: 'App Secure',
      appSecurePlaceholder: 'Please enter App Secure',
      mchId: 'Merchant ID',
      mchIdPlaceholder: 'Please enter Merchant ID',
      mchKey: 'Merchant Key',
      mchKeyPlaceholder: 'Please enter Merchant Key',
      url: 'URL',
      urlPlaceholder: 'Please enter URL',
      beanName: 'Bean Name',
      beanNamePlaceholder: 'Please enter Bean Name',
      suType: 'Supplier Type',
      suType1: 'Type 1',
      suType2: 'Type 2',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      supplierNameRequired: 'Supplier name is required',
      supplierNameMaxLength: 'Supplier name cannot exceed 30 characters',
      appIdRequired: 'App ID is required',
      appIdMaxLength: 'App ID cannot exceed 500 characters',
      appSecureRequired: 'App Secure is required',
      appSecureMaxLength: 'App Secure cannot exceed 500 characters',
      mchIdRequired: 'Merchant ID is required',
      mchIdMaxLength: 'Merchant ID cannot exceed 32 characters',
      mchKeyRequired: 'Merchant Key is required',
      mchKeyMaxLength: 'Merchant Key cannot exceed 128 characters',
      urlRequired: 'URL is required',
      urlMaxLength: 'URL cannot exceed 128 characters',
      beanNameRequired: 'Bean Name is required',
      beanNameMaxLength: 'Bean Name cannot exceed 50 characters'
    },
    editChainSupplier: {
      editSupplier: 'Edit Supplier',
      supplierName: 'Supplier Name',
      supplierNamePlaceholder: 'Please enter supplier name',
      appId: 'App ID',
      appIdPlaceholder: 'Please enter App ID',
      appSecure: 'App Secure',
      appSecurePlaceholder: 'Please enter App Secure',
      mchId: 'Merchant ID',
      mchIdPlaceholder: 'Please enter Merchant ID',
      mchKey: 'Merchant Key',
      mchKeyPlaceholder: 'Please enter Merchant Key',
      url: 'URL',
      urlPlaceholder: 'Please enter URL',
      beanName: 'Bean Name',
      beanNamePlaceholder: 'Please enter Bean Name',
      suType: 'Supplier Type',
      suType1: 'Type 1',
      suType2: 'Type 2',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      supplierNameRequired: 'Supplier name is required',
      supplierNameMaxLength: 'Supplier name cannot exceed 30 characters',
      appIdRequired: 'App ID is required',
      appIdMaxLength: 'App ID cannot exceed 500 characters',
      appSecureRequired: 'App Secure is required',
      appSecureMaxLength: 'App Secure cannot exceed 500 characters',
      mchIdRequired: 'Merchant ID is required',
      mchIdMaxLength: 'Merchant ID cannot exceed 32 characters',
      mchKeyRequired: 'Merchant Key is required',
      mchKeyMaxLength: 'Merchant Key cannot exceed 128 characters',
      urlRequired: 'URL is required',
      urlMaxLength: 'URL cannot exceed 128 characters',
      beanNameRequired: 'Bean Name is required',
      beanNameMaxLength: 'Bean Name cannot exceed 50 characters',
      supplierIdRequired: 'Supplier ID is required'
    }
  },
  zh: {
    chainProduct: {
      productList: '商品列表',
      productDetail: '商品详情',
      productId: '商品ID',
      productImage: '商品图片',
      productCatalog: '商品分类',
      productName: '商品名称',
      productUnit: '商品单位',
      sortOrder: '排序',
      status: '状态',
      createTime: '创建时间',
      operations: '操作',
      queryCondition: '查询条件',
      inputProdName: '请输入商品名称',
      confirmDeleteProduct: '确定删除商品吗？',
      onShelf: '已上架',
      offShelf: '未上架',
      editProduct: '修改商品',
      viewProduct: '查看详情',
      productSpec: '商品规格',
      specName: '规格名称',
      specValue: '规格值',
      price: '价格',
      purchaseQuantity: '采购数量',
      pricingStrategy: '定价策略',
      remark: '备注',
      fixedPrice: '固定价格',
      floatingPrice: '浮动价格',
      confirmOrder: '确认订单',
      orderSuccess: '下单成功',
      productDesc: '商品描述',
      coverPhoto: '封面图',
      carouselPhotos: '轮播图'
    },
    addChainSupplier: {
      addSupplier: '添加供应商',
      supplierName: '供应商名称',
      supplierNamePlaceholder: '请输入供应商名称',
      appId: 'App ID',
      appIdPlaceholder: '请输入App ID',
      appSecure: 'App Secure',
      appSecurePlaceholder: '请输入App Secure',
      mchId: '商户ID',
      mchIdPlaceholder: '请输入商户ID',
      mchKey: '商户密钥',
      mchKeyPlaceholder: '请输入商户密钥',
      url: 'URL',
      urlPlaceholder: '请输入URL',
      beanName: 'Bean名称',
      beanNamePlaceholder: '请输入Bean名称',
      suType: '供应商类型',
      suType1: '类型1',
      suType2: '类型2',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      supplierNameRequired: '供应商名称不能为空',
      supplierNameMaxLength: '供应商名称不能超过30个字符',
      appIdRequired: 'App ID不能为空',
      appIdMaxLength: 'App ID不能超过500个字符',
      appSecureRequired: 'App Secure不能为空',
      appSecureMaxLength: 'App Secure不能超过500个字符',
      mchIdRequired: '商户ID不能为空',
      mchIdMaxLength: '商户ID不能超过32个字符',
      mchKeyRequired: '商户密钥不能为空',
      mchKeyMaxLength: '商户密钥不能超过128个字符',
      urlRequired: 'URL不能为空',
      urlMaxLength: 'URL不能超过128个字符',
      beanNameRequired: 'Bean名称不能为空',
      beanNameMaxLength: 'Bean名称不能超过50个字符'
    },
    editChainSupplier: {
      editSupplier: '编辑供应商',
      supplierName: '供应商名称',
      supplierNamePlaceholder: '请输入供应商名称',
      appId: 'App ID',
      appIdPlaceholder: '请输入App ID',
      appSecure: 'App Secure',
      appSecurePlaceholder: '请输入App Secure',
      mchId: '商户ID',
      mchIdPlaceholder: '请输入商户ID',
      mchKey: '商户密钥',
      mchKeyPlaceholder: '请输入商户密钥',
      url: 'URL',
      urlPlaceholder: '请输入URL',
      beanName: 'Bean名称',
      beanNamePlaceholder: '请输入Bean名称',
      suType: '供应商类型',
      suType1: '类型1',
      suType2: '类型2',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      supplierNameRequired: '供应商名称不能为空',
      supplierNameMaxLength: '供应商名称不能超过30个字符',
      appIdRequired: 'App ID不能为空',
      appIdMaxLength: 'App ID不能超过500个字符',
      appSecureRequired: 'App Secure不能为空',
      appSecureMaxLength: 'App Secure不能超过500个字符',
      mchIdRequired: '商户ID不能为空',
      mchIdMaxLength: '商户ID不能超过32个字符',
      mchKeyRequired: '商户密钥不能为空',
      mchKeyMaxLength: '商户密钥不能超过128个字符',
      urlRequired: 'URL不能为空',
      urlMaxLength: 'URL不能超过128个字符',
      beanNameRequired: 'Bean名称不能为空',
      beanNameMaxLength: 'Bean名称不能超过50个字符',
      supplierIdRequired: '供应商ID不能为空'
    }
  }
}